import React from 'react';

function OccupationalTherapyPageSession() {
  return (
    <div className="services-details">
      <div className="container">
        <div className="row">
          <div className="col-xl-4 col-lg-5">
            <div className="services-details__sidebar">
              <div className="services-details__services-list">
                <ul className="services-details__services list-unstyled">
                  <li >
                    <a href="/applied-behavioral-analysis">Applied Behavioral Analysis</a>
                  </li>
                  <li>
                    <a href="/speech-language-pathology">Speech Language Pathology</a>
                  </li>
                  <li  className="active">
                    <a href="/occupational-therapy">Occupational Therapy</a>
                  </li>
                  <li>
                    <a href="/special-eduaction">Special Education</a>
                  </li>
                
                </ul>
              </div>
              <div className="banner-one">
                <div 
                  className="banner-one__bg"
                  style={{backgroundImage: "url(assets/images/backgrounds/BG9.png)"}}
                ></div>
                <div className="banner-one__shape-1 float-bob-x">
                  <img src="assets/images/shapes/9.png" alt="" />
                </div>
                <h3 className="banner-one__title">
                You’re not alone.
                  <br /> Let’s start this journey together.
                  <br /> <b>Contact us</b>
                </h3>
                <div className="banner-one__btn-box">
                  <a href="/contact" className="banner-one__btn thm-btn">Contact Now</a>
                </div>
              </div>
              <div className="sidebar__single sidebar__category">
                <h3 className="sidebar__title">Our Philosophy</h3>
                <ul className="sidebar__category-list list-unstyled">
                    <li><a href="javascript:;">Sensory Integration Therapy</a></li>
                    <li><a href="javascript:;">Neurodevelopmental Therapy (NDT)</a></li>
                    <li><a href="javascript:;">Play Therapy</a></li>
                    <li><a href="javascript:;">Cognitive Behaviour Therapy (CBT)</a></li>
                    <li><a href="javascript:;">Model of Human Occupation (MOHO)</a></li>
                </ul>
                </div>
            </div>
          </div>
          <div className="col-xl-8 col-lg-7">
            <div className="services-details__right">
              <div className="services-details__img">
                <img src="assets/images/services/Main-(770-377)1.jpg" alt="" />
              </div>
              <h3 className="services-details__title-1">Occupational Therapy</h3>
              <p className="services-details__text-1">
              At Ray of Hope, our Occupational Therapy department is committed to supporting children in building the foundational skills they need to meaningfully participate in everyday life.
             </p>
             <p>We offer a child-centered, up-to-date <b>sensory integration-based program</b> that draws from multiple evidence-based approaches. Our therapists are trained to deliver individualized care that respects each child’s sensory profile, developmental needs, and personal goals.</p>
             <p><b>Our focus includes:</b></p>
             <ul>
                <li>Gross and fine motor development</li>
                <li>Sensory processing</li>
                <li>Cognitive-perceptual skills</li>
                <li>Self-help skills</li>
                <li>Play and social interaction</li>
                <li>School readiness and participation in daily routines</li>
             </ul>
             <p>We believe that therapy should not only improve a child’s function but also boost their <b>confidence, connection</b>, and <b>independence </b>in the world around them.</p>
             <br/>
            
             <h3 className="services-details__title-3">The OT Process</h3>
              <ul className="services-details__process list-unstyled">
                <li>
                  <div className="icon">
                    <img src="assets/images/icons/Assessment.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Detailed Assessment</h3>
                 </li>
                <li>
                  <div className="icon">
                    <img src="assets/images/icons/Tailored intervention.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Planning and Intervention</h3>
                  </li>
                <li>
                  <div className="icon">
                     <img src="assets/images/icons/Ongoing.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Ongoing Monitoring</h3>
                </li>
                <li>
                  <div className="icon">
                    <img src="assets/images/icons/Collaborator.png" alt="Service Icon" />
                    <div className="services-details__process-count"></div>
                  </div>
                  <h3>Collaboration & Support</h3>
                  </li>
              </ul>
            
              
            </div>
          </div>



          {/* <section className="why-choose-one"> */}
                <div className="container">
                    <div className="row">
                    <div className="col-xl-4">
                        <div className="why-choose-one__left">
                        <div className="section-title text-left">
                            <span className="section-title__tagline">Who We SUpport</span>
                            <h2 className="section-title__title">
                            Our work supports children with diverse neurotypes
                            </h2>
                        </div>
                        </div>
                    </div>
                    <div className="col-xl-8">
                        <div className="why-choose-one__right">
                        <ul className="why-choose-one__list list-unstyled">
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                <img src="assets/images/icons/Sensory Difference Icon-01.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Sensory Processing Differences
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                  <img src="assets/images/icons/Autism Spectrum Disorder.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Autism Spectrum Disorder (ASD)
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                   <img src="assets/images/icons/ADHD.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Attention Deficit Hyperactivity Disorder (ADHD)
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                 <img src="assets/images/icons/Sensory Difference Icon-02.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Learning Disabilities / Intellectual Disabilities
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                 <img src="assets/images/icons/Down Syndrome.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Down Syndrome
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                  <img src="assets/images/icons/Epilepsy or Seizure.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Epilepsy or Seizure Disorders
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                   <img src="assets/images/icons/Icon.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Developmental Delays
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                  <img src="assets/images/icons/Cerebral Palsy.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Cerebral Palsy
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="why-choose-one__single">
                                <div className="icon">
                                  <img src="assets/images/icons/Genetic.png" alt="Service Icon" />
                                </div>
                                <div className="title">
                                <h3>
                                    <a href="javascript:;">
                                    Genetic Conditions
                                    </a>
                                </h3>
                                </div>
                            </div>
                            </li>
                        </ul>
                        
                        </div>
                    </div>
                    </div>
                </div>
                {/* </section> */}

                <div className="services-details__book">
                <div className="services-details__book-img">
                  <img src="assets/images/shapes/277-235.jpg" alt="" />
                </div>
                <div className="services-details__book-shape-1">
                  <img src="assets/images/shapes/services-details-book-shape-1.png" alt="" />
                </div>
                <div className="services-details__book-top">
                  <div className="icon">
                    <span className="icon-phone-call"></span>
                  </div>
                  <div className="content">
                    <p>Have Questions?</p>
                    
                  </div>
                </div>
                <div className="services-details__book-title-and-btn">
                  <h3 className="services-details__book-title">
                  Curious to know more?
                    <br /> We're just a call away — <b>Contact us.</b>
                  </h3>
                  <div className="services-details__book-btn-box">
                    <a href="/contact" className="services-details__book-btn thm-btn">
                      Contact Now
                    </a>
                  </div>
                </div>
              </div>

        </div>
      </div>
    </div>
  );
}

export default OccupationalTherapyPageSession;